module.exports = __webpack_public_path__ + "img/fi-rr-angle-small-left.cd782380.svg";